module.exports = __webpack_public_path__ + "static/img/footer-conac-blue.757e7611.png";